const getPronouns = () => ([
  {label: 'He/Him', value: 'he'},
  {label: 'She/Her', value: 'she'},
  {label: 'They/Them', value: 'they'},
  {label: 'Ze/Hir', value: 'ze'},
  {label: 'Other', value: 'other'},
]);

export default getPronouns;
